export const fontAwesomeOldXlStyle = {
  fontSize: "1.5em",
  verticalAlign: "-0.125em"
}